import { PostMessageSourceId, RegistrationNoType, TmaEModule, UserInteractionLog, VehicleType } from "@tm/models"
import { mapSourceIdToTmaModule } from "./mapper"
import { uniqueId, VehicleIdentificationDto } from "../.."

export const PostMessageHelper = {
    AddToBasket: {
        GetUserInteractionLog: (
            sourceId?: PostMessageSourceId,
            vehicleIdentification?: VehicleIdentificationDto,
            excludeWorkTaskVehicle?: boolean
        ): UserInteractionLog => {
            return {
                origin: mapSourceIdToTmaModule(TmaEModule.EXTERNALCATALOGUE, sourceId),
                eventId: uniqueId(),
                vehicleIdentification,
                excludeWorkTaskVehicle,
            }
        },
    },
    SearchTyre: {
        GetOrigin: (sourceId?: PostMessageSourceId): TmaEModule => {
            return mapSourceIdToTmaModule(TmaEModule.TM_TYRE_SEARCH, sourceId)
        },
    },
}

export function checkTruckModule(sourceId: PostMessageSourceId | undefined): boolean {
    switch (sourceId) {
        case "TM_MVC_TMTRUCK":
        case "TM_MVC_TRUCK_GARAGE":
            return true
        default:
            return false
    }
}

export function mapExternalVehicleIdentificationDto(
    isTruckModule: boolean,
    vehicleIdentification?: VehicleIdentificationDto,
    vinNumber?: string,
    manufacturerId?: number
) {
    const excludeWorkTaskVehicle = isTruckModule || (!!vehicleIdentification?.typeId && vehicleIdentification.typeId !== RegistrationNoType.None)

    if (!excludeWorkTaskVehicle) {
        return { excludeWorkTaskVehicle, vehicleIdentificationDto: undefined }
    }

    const vehicleIdentificationDto: VehicleIdentificationDto = {
        typeId: vehicleIdentification?.typeId ?? RegistrationNoType.None,
        key: vehicleIdentification?.key ?? "",
        vin: vehicleIdentification?.vin,
        vehicleType: vehicleIdentification?.vehicleType ?? VehicleType.PassengerCar,
        manufacturerId: vehicleIdentification?.manufacturerId ?? manufacturerId,
    }

    if (isTruckModule) {
        vehicleIdentificationDto.key = vehicleIdentificationDto.key || vinNumber || ""
        vehicleIdentificationDto.vin = vehicleIdentificationDto.vin || vinNumber
        vehicleIdentificationDto.vehicleType = VehicleType.CommercialVehicle
    }

    return { excludeWorkTaskVehicle, vehicleIdentificationDto }
}
